// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const LinkMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.5893 15.3034L9.4108 16.4819C7.78361 18.1091 5.14542 18.1091 3.51824 16.4819C1.89106 14.8547 1.89106 12.2165 3.51824 10.5893L4.69675 9.4108M15.3034 10.5893L16.4819 9.4108C18.109 7.78361 18.109 5.14542 16.4819 3.51824C14.8547 1.89106 12.2165 1.89106 10.5893 3.51824L9.4108 4.69675M7.08339 12.9167L12.9167 7.08337" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
